import React from "react";
import {
  FieldError,
  FieldValues,
  UseFormClearErrors,
  UseFormRegisterReturn,
  UseFormSetError,
  UseFormSetValue,
  useFormContext,
  useFormState,
} from "react-hook-form";
import { getPropValue } from "utils/object";
import Field from "./ui/Field";
import { getErrorMessage } from "./utils";

interface InputProps extends UseFormRegisterReturn<string> {
  id: string;
}

export interface FieldApi {
  inputProps: InputProps;
  error: FieldError;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
}

interface Props {
  name: string;
  label?: React.ReactNode;
  type?: string;
  children: (props: FieldApi) => React.ReactNode;
  errorName?: string;
}

const FieldContainer: React.FC<Props> = ({
  name,
  label,
  type,
  children,
  errorName,
}) => {
  const { register, setError, clearErrors, setValue } = useFormContext();
  const { errors } = useFormState();
  const inputProps = register(name, { valueAsNumber: type === "number" });
  const error = getPropValue(errors, errorName || name) as FieldError;
  const errorMessage = getErrorMessage(error);

  return (
    <Field name={name} label={label} errorMessage={errorMessage}>
      {children({
        inputProps: { ...inputProps, id: name },
        error,
        setError,
        clearErrors,
        setValue,
      })}
    </Field>
  );
};

export default FieldContainer;
